import { setInavLocationAction } from '../ducks/requestDuck';
import { convertPage } from './convertPage';

export const createInav = (pathname, dispatch) => {
  const [page] = pathname.split('/').slice(3);

  let inavLocation = `${convertPage(page)}-packages`;
  if (page === 'vacation-packages' || page === 'packages') {
    inavLocation = 'hp-packages';
  }

  dispatch(setInavLocationAction(inavLocation));
};
